// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__CNDDm","headers":"style_headers__z2ecF"};